"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TRAFFIC_EID_USER_QUEUED = exports.TRAFFIC_EID_USER_IDLE = exports.TRAFFIC_EID_LE_SOCKET_ONOPEN = exports.TRAFFIC_EID_LE_SOCKET_ONMESSAGE = exports.TRAFFIC_EID_LE_SOCKET_ONERROR = exports.TRAFFIC_EID_LE_SOCKET_ONCLOSE = exports.TRAFFIC_EID_INPUT_SUBMIT = exports.TRAFFIC_EID_END_CHAT_CLICK = exports.TRAFFIC_EID_CHAT_RESET_CLICK = exports.TRAFFIC_EID_CHAT_LEAVE_QUEUE_CLICK = exports.TRAFFIC_EID_SURVEY_QUESTION_SHOWN = exports.TRAFFIC_EID_SURVEY_QUESTION_ANSWERED = exports.TRAFFIC_EID_RAC_CALLED = exports.TRAFFIC_EID_BOT_START = exports.TRAFFIC_EID_BOT_MESSAGE_SENT = exports.TRAFFIC_EID_BOT_BUTTON_VIEW = exports.TRAFFIC_EID_BOT_BUTTON_CLICK = exports.TRAFFIC_EID_AGENT_UNAVAILABLE = exports.TRAFFIC_EID_AGENT_START = exports.TRAFFIC_EID_AGENT_MESSAGE_SENT = exports.TRAFFIC_EID_AGENT_END = exports.SLASH_COMMAND_SURVEY = exports.SLASH_COMMAND_DEBUG_END = exports.SLASH_COMMAND_DEBUG = exports.SLASH_COMMAND_CHAT_RESET = exports.SLASH_COMMAND_CHAT_LEAVE_QUEUE = exports.SLASH_COMMAND_CHAT_END = exports.PROJECT_ID_CSS_SURVEY_BOT = exports.PRODUCT_DEFAULT = exports.PAYLOAD_TYPE = exports.LOCALSTORAGE_KEY_STORE_EXPIRES = exports.LOCALSTORAGE_KEY_STORE = exports.EVENT_TYPE_RETURN_WELCOME = exports.EVENT_TYPE_CHAT_OFFLINE = exports.EVENT_TYPE_CHAT_LEAVE_QUEUE = exports.CONVERSATION_TYPE_WELCOME = exports.CONVERSATION_TYPE_WAIT_FOR_HUMAN = exports.CONVERSATION_TYPE_UTTERANCE = exports.CONVERSATION_TYPE_TEXT_HUMAN_START = exports.CONVERSATION_TYPE_TEXT_HUMAN_LEAVE = exports.CONVERSATION_TYPE_TEXT_HUMAN_JOIN = exports.CONVERSATION_TYPE_TEXT_HUMAN_END = exports.CONVERSATION_TYPE_TEXT_HUMAN = exports.CONVERSATION_TYPE_TEXT_BOT = exports.CONVERSATION_TYPE_DIAG_BOT = exports.CONVERSATION_TYPE_BUTTONS = exports.CONTEXT_LIVE_ENGAGE = exports.CONTEXT_CHATBOTS_API = exports.CHAT_PARTICIPANT_ID_CHATBOT = exports.CHATBOT_API_ENDPOINTS = exports.HOST_PATH = exports.API_HOST = exports.ENV_STRINGS = void 0;

/* eslint-disable no-process-env */
var ENV_STRINGS = {
  dev: 'dev',
  prod: 'prod',
  test: 'test'
};
exports.ENV_STRINGS = ENV_STRINGS;
var API_HOST = 'origin-chatbots-api';
exports.API_HOST = API_HOST;
var HOST_PATH = 'https://www.godaddy.com/help';
exports.HOST_PATH = HOST_PATH;
var CHATBOT_API_ENDPOINTS = {
  ADD_CONTACT: 'addContact',
  AGENT_AVAILABILITY: 'agentAvailability',
  AGENT_WAITTIME: 'agentWaitTime',
  DETECT_INTENT: 'detectIntent',
  POST_TO_CRM: 'postToCRM',
  QUERY_INTENT: 'queryIntent'
};
exports.CHATBOT_API_ENDPOINTS = CHATBOT_API_ENDPOINTS;
var CHAT_PARTICIPANT_ID_CHATBOT = 'chat-bot';
exports.CHAT_PARTICIPANT_ID_CHATBOT = CHAT_PARTICIPANT_ID_CHATBOT;
var CONTEXT_CHATBOTS_API = 'chatbotsApi';
exports.CONTEXT_CHATBOTS_API = CONTEXT_CHATBOTS_API;
var CONTEXT_LIVE_ENGAGE = 'liveEngage';
exports.CONTEXT_LIVE_ENGAGE = CONTEXT_LIVE_ENGAGE;
var CONVERSATION_TYPE_BUTTONS = 'buttons';
exports.CONVERSATION_TYPE_BUTTONS = CONVERSATION_TYPE_BUTTONS;
var CONVERSATION_TYPE_DIAG_BOT = 'diag-bot';
exports.CONVERSATION_TYPE_DIAG_BOT = CONVERSATION_TYPE_DIAG_BOT;
var CONVERSATION_TYPE_TEXT_BOT = 'text-bot';
exports.CONVERSATION_TYPE_TEXT_BOT = CONVERSATION_TYPE_TEXT_BOT;
var CONVERSATION_TYPE_TEXT_HUMAN = 'text-human';
exports.CONVERSATION_TYPE_TEXT_HUMAN = CONVERSATION_TYPE_TEXT_HUMAN;
var CONVERSATION_TYPE_TEXT_HUMAN_END = 'text-human-end';
exports.CONVERSATION_TYPE_TEXT_HUMAN_END = CONVERSATION_TYPE_TEXT_HUMAN_END;
var CONVERSATION_TYPE_TEXT_HUMAN_JOIN = 'text-human-join';
exports.CONVERSATION_TYPE_TEXT_HUMAN_JOIN = CONVERSATION_TYPE_TEXT_HUMAN_JOIN;
var CONVERSATION_TYPE_TEXT_HUMAN_LEAVE = 'text-human-leave';
exports.CONVERSATION_TYPE_TEXT_HUMAN_LEAVE = CONVERSATION_TYPE_TEXT_HUMAN_LEAVE;
var CONVERSATION_TYPE_TEXT_HUMAN_START = 'text-human-start';
exports.CONVERSATION_TYPE_TEXT_HUMAN_START = CONVERSATION_TYPE_TEXT_HUMAN_START;
var CONVERSATION_TYPE_UTTERANCE = 'utterance';
exports.CONVERSATION_TYPE_UTTERANCE = CONVERSATION_TYPE_UTTERANCE;
var CONVERSATION_TYPE_WAIT_FOR_HUMAN = 'wait-for-human';
exports.CONVERSATION_TYPE_WAIT_FOR_HUMAN = CONVERSATION_TYPE_WAIT_FOR_HUMAN;
var CONVERSATION_TYPE_WELCOME = 'welcome';
exports.CONVERSATION_TYPE_WELCOME = CONVERSATION_TYPE_WELCOME;
var EVENT_TYPE_CHAT_LEAVE_QUEUE = 'abort-welcome';
exports.EVENT_TYPE_CHAT_LEAVE_QUEUE = EVENT_TYPE_CHAT_LEAVE_QUEUE;
var EVENT_TYPE_CHAT_OFFLINE = 'chatoffline-phone';
exports.EVENT_TYPE_CHAT_OFFLINE = EVENT_TYPE_CHAT_OFFLINE;
var EVENT_TYPE_RETURN_WELCOME = 'return-welcome';
exports.EVENT_TYPE_RETURN_WELCOME = EVENT_TYPE_RETURN_WELCOME;
var LOCALSTORAGE_KEY_STORE = 'help-chat-store';
exports.LOCALSTORAGE_KEY_STORE = LOCALSTORAGE_KEY_STORE;
var LOCALSTORAGE_KEY_STORE_EXPIRES = 'help-chat-store-expires';
exports.LOCALSTORAGE_KEY_STORE_EXPIRES = LOCALSTORAGE_KEY_STORE_EXPIRES;
var PAYLOAD_TYPE = {
  AGENT_TRANSFER: 'agentTransfer',
  API: 'api',
  AUTH_CHECK: 'authCheck',
  BUTTON: 'button',
  EVENT: 'event',
  QUERY_BOT_AGENT: 'queryBotAgent',
  POST_TO_CRM: 'postToCRM',
  SET_BOT_AGENT: 'setBotAgent',
  SET_STATE: 'setState',
  TEXT: 'text',
  VALIDATOR: 'validator',
  SETTINGS: 'settings'
};
exports.PAYLOAD_TYPE = PAYLOAD_TYPE;
var PRODUCT_DEFAULT = 'product-default';
exports.PRODUCT_DEFAULT = PRODUCT_DEFAULT;
var PROJECT_ID_CSS_SURVEY_BOT = 'css-survey-bot';
exports.PROJECT_ID_CSS_SURVEY_BOT = PROJECT_ID_CSS_SURVEY_BOT;
var SLASH_COMMAND_CHAT_END = '/chatend';
exports.SLASH_COMMAND_CHAT_END = SLASH_COMMAND_CHAT_END;
var SLASH_COMMAND_CHAT_LEAVE_QUEUE = '/chatleavequeue';
exports.SLASH_COMMAND_CHAT_LEAVE_QUEUE = SLASH_COMMAND_CHAT_LEAVE_QUEUE;
var SLASH_COMMAND_CHAT_RESET = '/chatreset';
exports.SLASH_COMMAND_CHAT_RESET = SLASH_COMMAND_CHAT_RESET;
var SLASH_COMMAND_DEBUG = '/debug';
exports.SLASH_COMMAND_DEBUG = SLASH_COMMAND_DEBUG;
var SLASH_COMMAND_DEBUG_END = '/debugend';
exports.SLASH_COMMAND_DEBUG_END = SLASH_COMMAND_DEBUG_END;
var SLASH_COMMAND_SURVEY = '/survey'; // chat.agent

exports.SLASH_COMMAND_SURVEY = SLASH_COMMAND_SURVEY;
var TRAFFIC_EID_AGENT_END = 'dc.sidekick.chat.agent.end';
exports.TRAFFIC_EID_AGENT_END = TRAFFIC_EID_AGENT_END;
var TRAFFIC_EID_AGENT_MESSAGE_SENT = 'dc.sidekick.chat.agent-message.sent';
exports.TRAFFIC_EID_AGENT_MESSAGE_SENT = TRAFFIC_EID_AGENT_MESSAGE_SENT;
var TRAFFIC_EID_AGENT_START = 'dc.sidekick.chat.agent.start';
exports.TRAFFIC_EID_AGENT_START = TRAFFIC_EID_AGENT_START;
var TRAFFIC_EID_AGENT_UNAVAILABLE = 'dc.sidekick.chat.agent.unavailable'; // chat.bot

exports.TRAFFIC_EID_AGENT_UNAVAILABLE = TRAFFIC_EID_AGENT_UNAVAILABLE;
var TRAFFIC_EID_BOT_BUTTON_CLICK = 'dc.sidekick.chat.bot-button.click';
exports.TRAFFIC_EID_BOT_BUTTON_CLICK = TRAFFIC_EID_BOT_BUTTON_CLICK;
var TRAFFIC_EID_BOT_BUTTON_VIEW = 'dc.sidekick.chat.bot-buttons.view';
exports.TRAFFIC_EID_BOT_BUTTON_VIEW = TRAFFIC_EID_BOT_BUTTON_VIEW;
var TRAFFIC_EID_BOT_MESSAGE_SENT = 'dc.sidekick.chat.bot-message.sent';
exports.TRAFFIC_EID_BOT_MESSAGE_SENT = TRAFFIC_EID_BOT_MESSAGE_SENT;
var TRAFFIC_EID_BOT_START = 'dc.sidekick.chat.bot.start';
exports.TRAFFIC_EID_BOT_START = TRAFFIC_EID_BOT_START;
var TRAFFIC_EID_RAC_CALLED = 'dc.sidekick.chat.bot-rac.triggered';
exports.TRAFFIC_EID_RAC_CALLED = TRAFFIC_EID_RAC_CALLED;
var TRAFFIC_EID_SURVEY_QUESTION_ANSWERED = 'dc.sidekick.chat.bot-survey.answered';
exports.TRAFFIC_EID_SURVEY_QUESTION_ANSWERED = TRAFFIC_EID_SURVEY_QUESTION_ANSWERED;
var TRAFFIC_EID_SURVEY_QUESTION_SHOWN = 'dc.sidekick.chat.bot-survey.shown'; // chat.<others>

exports.TRAFFIC_EID_SURVEY_QUESTION_SHOWN = TRAFFIC_EID_SURVEY_QUESTION_SHOWN;
var TRAFFIC_EID_CHAT_LEAVE_QUEUE_CLICK = 'dc.sidekick.chat.leave-queue.click';
exports.TRAFFIC_EID_CHAT_LEAVE_QUEUE_CLICK = TRAFFIC_EID_CHAT_LEAVE_QUEUE_CLICK;
var TRAFFIC_EID_CHAT_RESET_CLICK = 'dc.sidekick.chat.reset.click'; // reset a bot chat

exports.TRAFFIC_EID_CHAT_RESET_CLICK = TRAFFIC_EID_CHAT_RESET_CLICK;
var TRAFFIC_EID_END_CHAT_CLICK = 'dc.sidekick.chat.end-chat.click'; // end and reset a live engage chat

exports.TRAFFIC_EID_END_CHAT_CLICK = TRAFFIC_EID_END_CHAT_CLICK;
var TRAFFIC_EID_INPUT_SUBMIT = 'dc.sidekick.chat.input.submit'; // chat.le

exports.TRAFFIC_EID_INPUT_SUBMIT = TRAFFIC_EID_INPUT_SUBMIT;
var TRAFFIC_EID_LE_SOCKET_ONCLOSE = 'dc.sidekick.chat.le.onclose';
exports.TRAFFIC_EID_LE_SOCKET_ONCLOSE = TRAFFIC_EID_LE_SOCKET_ONCLOSE;
var TRAFFIC_EID_LE_SOCKET_ONERROR = 'dc.sidekick.chat.le.onerror';
exports.TRAFFIC_EID_LE_SOCKET_ONERROR = TRAFFIC_EID_LE_SOCKET_ONERROR;
var TRAFFIC_EID_LE_SOCKET_ONMESSAGE = 'dc.sidekick.chat.le.onmessage';
exports.TRAFFIC_EID_LE_SOCKET_ONMESSAGE = TRAFFIC_EID_LE_SOCKET_ONMESSAGE;
var TRAFFIC_EID_LE_SOCKET_ONOPEN = 'dc.sidekick.chat.le.onopen'; // chat.user

exports.TRAFFIC_EID_LE_SOCKET_ONOPEN = TRAFFIC_EID_LE_SOCKET_ONOPEN;
var TRAFFIC_EID_USER_IDLE = 'dc.sidekick.chat.user.idle';
exports.TRAFFIC_EID_USER_IDLE = TRAFFIC_EID_USER_IDLE;
var TRAFFIC_EID_USER_QUEUED = 'dc.sidekick.chat.user.queued';
exports.TRAFFIC_EID_USER_QUEUED = TRAFFIC_EID_USER_QUEUED;